import { defineComponent as _defineComponent } from 'vue'
import SidebarHeadline from '@/shared/components/SidebarHeadline.vue';
import FormFieldInput from '@/shared/components/form/FormFieldInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepAssessmentName',
  props: {
    value: { default: '' }
  },
  emits: ["update:value", "navigate:forward"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:value', name: string): string;
  (e: 'navigate:forward'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, SidebarHeadline, FormFieldInput }
}

})